/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.11",
    versionName: "0.2.0-nightly.2025.11.11",
    versionChannel: "nightly",
    buildDate: "2025-11-11T00:07:52.785Z",
    commitHash: "c2b754d7602b9ea5ae2b89e90383c72acd3fae08",
};
